import React from 'react';

const LoadingScreen = ({ progress, text }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div style={{ marginBottom: '32px' }}>
          <div style={{ width: '64px', height: '64px', margin: '0 auto 16px' }}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
              <path fill="#3b82f6" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
          </div>
          <h2 className="loading-title">Generating report</h2>
          <p className="loading-subtitle">MediScan — Processing your medical data</p>
        </div>
        
        <div style={{ marginBottom: '24px' }}>
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            marginTop: '8px' 
          }}>
            <p className="loading-text" style={{ margin: 0 }}>{text}</p>
            <span style={{ 
              fontSize: '14px', 
              color: '#94a3b8', 
              fontWeight: '600' 
            }}>
              {progress}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;